import { useEffect, useRef } from "react";

export function useKeybind(keybind: (e: KeyboardEvent) => boolean, callback: () => void) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (keybind(event)) {
        event.preventDefault();
        callback();
      }
    };
    window.addEventListener("keydown", handleKeyDown, true);
    return () => {
      window.removeEventListener("keydown", handleKeyDown, true);
    };
  }, [keybind, callback]);
}

export function useKeybinds(
  bindings: Array<{
    check: (e: KeyboardEvent) => boolean;
    handler: () => void;
  }>,
  allowMultiple = false,
) {
  const bindingsRef = useRef(bindings);
  bindingsRef.current = bindings;
  const allowMultipleRef = useRef(allowMultiple);
  allowMultipleRef.current = allowMultiple;

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      for (const { check, handler } of bindingsRef.current) {
        if (check(event)) {
          event.preventDefault();
          handler();
          if (!allowMultipleRef.current) break;
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown, true);
    return () => window.removeEventListener("keydown", handleKeyDown, true);
  }, []);
}

export function checkInputType(e: KeyboardEvent) {
  const target = e.target as HTMLElement;
  const tagName = target.tagName.toLowerCase();

  if (
    tagName === "textarea" ||
    tagName === "select" ||
    tagName === "button" ||
    target.isContentEditable ||
    target.closest('[role="combobox"]') ||
    target.closest('[role="listbox"]') ||
    target.closest('[role="option"]') ||
    target.closest('[role="button"]')
  ) {
    return false;
  }

  return true;
}
